import { render } from "./drawing-manager.vue?vue&type=template&id=85ba3b8a"
import script from "./drawing-manager.vue?vue&type=script&lang=js"
export * from "./drawing-manager.vue?vue&type=script&lang=js"
script.render = render

export default script